<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.9375 22.1895C16.9081 22.1895 20.9375 18.16 20.9375 13.1895C20.9375 8.21889 16.9081 4.18945 11.9375 4.18945C6.96694 4.18945 2.9375 8.21889 2.9375 13.1895C2.9375 18.16 6.96694 22.1895 11.9375 22.1895Z"
      fill="#D5D8DC"
    />
    <path
      d="M17.2856 1.99916L16 3.53125L20.5963 7.38798L21.8818 5.85589L17.2856 1.99916Z"
      fill="#3CB149"
    />
    <path
      d="M1.99958 5.85658L3.28516 7.38867L7.88142 3.53195L6.59585 1.99986L1.99958 5.85658Z"
      fill="#3CB149"
    />
    <path
      d="M12.5 8H11V14L15.75 16.85L16.5 15.62L12.5 13.25V8Z"
      fill="#363C43"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
